import React, {Component} from 'react'
import PropsTypes from 'prop-types'
import WorkersPagination from "./WorkersPagination"
import {Alert, Modal} from "reactstrap"
import WorkerRecord from "./WorkerRecord"
import CreateNewWorker from "./CreateNewWorker"
import UpdateWorkerDataForm from "./UpdateWorkerDataForm"
import ChooseDevices from "./ChooseDevices"
import IAAStatistics from "./iaa/IAAStatistics"

class WorkersPage extends Component {
    state = {
        device: 'd1'
    }

    _handleChangeDevice = (device) => {
        this.setState({device})
    }

    render() {
        const {total, pagination, error, docs, isModalOpen} = this.props
        const {device} = this.state

        return (
            <div className='WorkersPage'>
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Workers ({total})</h2>
                <div>
                    <div className='row'>
                        <CreateNewWorker onRefreshPage={this.props.onRefreshPage}/>
                        <ChooseDevices onChange={this._handleChangeDevice}/>
                        <IAAStatistics/>
                    </div>
                    <div className='row table-row'>
                        <div className='Order col'>#</div>
                        <div className='Score col'>Score</div>
                        <div className='col'>User name</div>
                        <div className='col'>Password</div>
                        <div className='col'>Secret code</div>
                        <div className='Note col'>Note</div>
                        <div className='col'>Proxy</div>
                        <div className='col'>Status</div>
                        <div className='col'>Actions</div>
                    </div>
                    {
                        docs.map((record, index) => {
                            return <WorkerRecord
                                order={index + 1}
                                device={device}
                                key={record._id} record={record}
                                onRefreshPage={this.props.onRefreshPage}
                                removeWorkerFormState={this.props.removeWorkerFormState}
                                onToggleModal={this.props.onToggleModal}
                                onChangeModalData={this.props.onChangeModalData}
                            />
                        })
                    }
                </div>
                <WorkersPagination paginationInfo={pagination} onChangePage={this.props.onChangePage}/>
                <Modal isOpen={isModalOpen} toggle={this.props.onToggleModal} className={this.props.className}>
                    <UpdateWorkerDataForm
                        onToggleModal={this.props.onToggleModal}
                        modalData={this.props.modalData}
                        onChangeModalData={this.props.onChangeModalData}
                        onUpdateListWorker={this.props.onUpdateListWorker}
                        onCloseModal={this.props.onCloseModal}
                    />
                </Modal>
            </div>
        )
    }
}

WorkersPage.propsTypes = {
    onUpdateListWorker: PropsTypes.func.isRequired,
    onCloseModal: PropsTypes.func.isRequired,
    onToggleModal: PropsTypes.func.isRequired,
    onChangeModalData: PropsTypes.func.isRequired,
    removeWorkerFormState: PropsTypes.func.isRequired,
    onRefreshPage: PropsTypes.func.isRequired,
    onChangePage: PropsTypes.func.isRequired,
    total: PropsTypes.number,
    pagination: PropsTypes.object.isRequired,
    error: PropsTypes.string,
    docs: PropsTypes.array.isRequired,
    isModalOpen: PropsTypes.bool.isRequired,
    modalData: PropsTypes.object.isRequired,
}

export default WorkersPage



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/WorkersPage.js